import {View} from '@fantasmagames/slot/src/common/view/View';
import {SpriteButton} from '@fantasmagames/core/src/display/SpriteButton';
import {StopAutoplayButton} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButton';
import {ObjectSize, Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class StopAutoplayButtonView extends View {
	public static readonly STOP_AUTOPLAY_BUTTON_CLICKED: string = 'STOP_AUTOPLAY_BUTTON_CLICKED';

	protected _spinsLeftText: PIXI.Text;
	protected _spinsLeftStyle: PIXI.TextStyle;
	protected _autoplayButton: SpriteButton;

	public init(): void {
		super.init();

		this.setupSpinButton();
		this.setupSpinsLeftText();
	}

	public updateSpinsLeft(currentSpin: number, totalSpins: number): void {
		this._autoplayButton.addChild(this._spinsLeftText);

		this._spinsLeftText.alpha = 0;
		this._spinsLeftText.text = `${currentSpin}/${totalSpins}`;
		this._spinsLeftText.alpha = 1;
	}

	public initAutoplay(): void {
		this._autoplayButton.visible = true;
		this._spinsLeftText.text = '';
		this._spinsLeftText.visible = true;
	}

	public uninitAutoplay(): void {
		this._autoplayButton.visible = false;
		this._spinsLeftText.visible = false;
	}

	protected setupSpinButton(): void {
		this._autoplayButton = new StopAutoplayButton(null, this.updateManager, this.resources);

		this.setupEventsForButtons();
		this.container.addChild(this._autoplayButton);

		const autplayButtonPosition: Position = this.layout.getPosition('SPIN_BUTTON');
		this._autoplayButton.position.set(autplayButtonPosition.x, autplayButtonPosition.y);
		this._autoplayButton.enable();

		const size: ObjectSize = this.layout.getSize('SPIN_BUTTON', this.viewType);
		this._autoplayButton.hitArea = new PIXI.Circle(0, 0, size.width / 2);
	}

	protected setupSpinsLeftText(): void {
		this._spinsLeftStyle = this.textStyles.spinsLeftStyle;

		this._spinsLeftText = new PIXI.Text('', this._spinsLeftStyle);
		this._spinsLeftText.anchor.set(0.5, 0.5);
		this.uninitAutoplay();
	}

	protected setupEventsForButtons(): void {
		this._autoplayButton.callback = this.onStopAutoplayButtonClicked.bind(this);
	}

	protected onStopAutoplayButtonClicked(): void {
		this.uninitAutoplay();
		this.emit(StopAutoplayButtonView.STOP_AUTOPLAY_BUTTON_CLICKED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonView.ts